import {
  useAddCacheTagHeader,
  useAddServiceCacheTagHeader,
} from '@backmarket/nuxt-module-http-cache/composables/useAddCacheTagHeader'

import { useFetchFormattedCMSSections } from '~/scopes/cms/composables/useFetchFormattedCMSSections'
import { useAddSectionsCacheTagHeader } from '~/scopes/cms/composables/useSetCMSPageCacheTagHeader'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'

// Set cache Header for Cloudflare
export function useAddCacheTags() {
  useAddServiceCacheTagHeader()

  const { pickersResponseCacheTagHeader } = useFetchPickers()
  useAddCacheTagHeader(pickersResponseCacheTagHeader.value)

  // FIXME: contact content team to add dedupe: 'defer'
  const { data: cmsSections } = useFetchFormattedCMSSections({
    timeout: 2000,
  })
  useAddSectionsCacheTagHeader(cmsSections.value?.id)
}
